import React from 'react';
import { getBuilderURL } from '../common/utils/builder-url-util';
import { getCookie } from '../common/utils/api_utils';

let token = getCookie('token');
if (!token) {
  token = '';
}

export const typeIcons = {
  Page: <i className="wb webconnect-file-alt" />,
  Snippet: <i className="wb webconnect-layout-text-window-reverse" />,
  Modal: <i className="wb webconnect-files-alt" />,
  'Custom Segment': <i className="wb webconnect-breadcrumb" />,
  'Sub Page': <i className="wb webconnect-file-earmark-richtext" />,
  'PDF Template': <i className="wb webconnect-layout-text-sidebar-reverse" />,
  'Page Layout': <i className="wb webconnect-breadcrumb" />,
  Event: <i className="wb webconnect-diagram-3-fill" />,
  Collection: <i className="wb webconnect-database" />,
  'External API': <i className="wb webconnect-rocket" />,
  'Email Template': <i className="wb webconnect-envelope-fill" />,
  'SMS Template': <i className="wb webconnect-chat-left-text" />,
  'Tooltip Template': <i className="wb webconnect-info-circle-fill" />,
  'Agreement Template': <i className="wb webconnect-edit" />,
  'Typesense Search Template': <i className="wb webconnect-search" />,
  'Socket IO Template': <i className="wb webconnect-lightning-charge-fill" />,
  'Custom Component': <i className="wb webconnect-easel" />,
  'Custom Data Mapping': <i className="wb webconnect-bezier2" />,
  'Background Task': <i className="wb webconnect-alarm" />,
  'Custom Function': <i className="wb webconnect-edit" />,
};

const redirectUrl = getBuilderURL();

export const createPagesURL = (version, projectId) => {
  return {
    Page: `${redirectUrl}editor/${version}/v/${projectId}/loader?open-modal=create-page&token=${token}`,
    Snippet: `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`,
    Modal: `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`,
    'Custom Segment': `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`,
    'Sub Page': `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`,
    'PDF Template': `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`,
    'Page Layout': `${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`,
    Event: `/events/${version}/v/${projectId}/create`,
    Collection: `/collections/${version}/v/${projectId}/create`,
    'External API': `/externalapi/${version}/v/${projectId}/create`,
    'Email Template': `/template/${version}/v/${projectId}/mails/create`,
    'SMS Template': `/template/${version}/v/${projectId}/messages/create`,
    'Tooltip Template': `/template/${version}/v/${projectId}/tooltips/create`,
    'Agreement Template': `/template/${version}/v/${projectId}/agreements/create`,
    'Typesense Search Template': `/template/${version}/v/${projectId}/typesenseSearch/create`,
    'Socket IO Template': `/template/${version}/v/${projectId}/socketIo/create`,
    'Custom Component': `/custom-component/${version}/v/${projectId}/customComponent/create`,
    'Custom Data Mapping': `/custom-component/${version}/v/${projectId}/customDataMapping/create`,
    'Background Task': `/schedule/${version}/v/${projectId}/create`,
    'Custom Function': `/custom-component/${version}/v/${projectId}/customFunction/create`,
  };
};

export const appSettingsURL = (version, projectId) => {
  return {
    Collections: `/collections/${version}/v/${projectId}`,
    Events: `/events/${version}/v/${projectId}`,
    Plugins: `/plugin/${version}/v/${projectId}`,
    'App Setting': `/app-setting/${version}/v/${projectId}/setting/app-config`,
    'Custom CSS': `/app-setting/${version}/v/${projectId}/setting/custom-css`,
    'Custom JS': `/app-setting/${version}/v/${projectId}/setting/custom-js`,
    'PWA Config': `/app-setting/${version}/v/${projectId}/setting/pwa-config`,
    'Developer API': `/app-setting/${version}/v/${projectId}/setting/devKey`,
    'Data Encryption': `/app-setting/${version}/v/${projectId}/setting/encryption-section`,
    Template: `/template/${version}/v/${projectId}/`,
    'Data Source': `/data-connector/${version}/v/${projectId}`,
    Localization: `/app-setting/${version}/v/${projectId}/setting/localization-section`,
    'System Logs': `/logger/${version}/v/${projectId}`,
    'Background Task': `/schedule/${version}/v/${projectId}`,
    'Delete Permission': `/permission/${version}/v/${projectId}`,
    'Code Export': `/deployment-setting/${version}/v/${projectId}/code-export`,
    'App Constant': `/app-setting/${version}/v/${projectId}/setting/appConstant`,
    'Page Setting': `/app-setting/${version}/v/${projectId}/setting/pageSetting`,
    'Loading Icon': `/app-setting/${version}/v/${projectId}/setting/loadingIcon`,
    'Robots.txt': `/app-setting/${version}/v/${projectId}/setting/robots`,
    'Sitemap.xml': `/app-setting/${version}/v/${projectId}/setting/sitemapXml`,
    Environment: `/app-setting/${version}/v/${projectId}/setting/environment`,
    'Project Version': `/app-setting/${version}/v/${projectId}/setting/version`,
    'Notification Setting': `/app-setting/${version}/v/${projectId}/setting/notificationSetting`,
    Resources: `/app-setting/${version}/v/${projectId}/setting/resources`,
    Profiler: `/app-setting/${version}/v/${projectId}/setting/profiler-section`,
    'System Activity': `/app-setting/${version}/v/${projectId}/setting/system-activity`,
    'Publish Activity': `/app-setting/${version}/v/${projectId}/setting/publish-activity`,
    'Page Snapshot': `/app-setting/${version}/v/${projectId}/setting/pageSnapshot`,
    'Snippet Snapshot': `/app-setting/${version}/v/${projectId}/setting/snippetShapshot`,
    'Collection Snapshot': `/app-setting/${version}/v/${projectId}/setting/collectionSnapshot`,
    'Custom Fonts': `/app-setting/${version}/v/${projectId}/setting/customFonts`,
    'Global Theme': `/app-setting/${version}/v/${projectId}/setting/globalTheme`,
    'Typography & Colours': `/app-setting/${version}/v/${projectId}/setting/typographyColours`,
    'Custom Component': `/custom-component/${version}/v/${projectId}/customComponent`,
    'Custom Data Mapping': `/custom-component/${version}/v/${projectId}/customDataMapping`,
    'External APIs': `/externalapi/${version}/v/${projectId}`,
    'AI Model Configuration': `/app-setting/${version}/v/${projectId}/setting/aiModelConfig-section`,
    'Loader Screen': `/app-setting/${version}/v/${projectId}/setting/loader-screen`,
    'Custom Function': `/custom-component/${version}/v/${projectId}/customFunction`,
    'Import From Figma': `/app-setting/${version}/v/${projectId}/setting/figmaConfig-section`,
    'PHI Audit': `/app-setting/${version}/v/${projectId}/setting/phi-audit`,
  };
};

export const originURLMapping = (type) => {
  const domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}`;
  const surfaceTypes = [
    'Page',
    'Snippet',
    'Modal',
    'Custom Segment',
    'Sub Page',
    'PDF Template',
    'Page Layout',
  ];
  if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
    redirectUrl = surfaceTypes.includes(type)
      ? `http://${domainName}:6075`
      : `http://${domainName}:9075`;
  } else if (process.env.REACT_APP_ENVIRONMENT === 'STAGING') {
    if (surfaceTypes.includes(type)) {
      const updatedDomain = domainName.replace('builderc.webkonnect.xyz', 'builder.webkonnect.xyz');
      redirectUrl = `https://${updatedDomain}`;
    }
  } else {
    if (surfaceTypes.includes(type)) {
      const updatedDomain = domainName.replace('builderc.mydrapcode.com', 'builder.mydrapcode.com');
      redirectUrl = `https://${updatedDomain}`;
    }
  }
  return redirectUrl;
};

export const types = [
  'Agreement Template',
  'Background Task',
  'Collection',
  'Custom Component',
  'Custom Data Mapping',
  'Custom Function',
  'Custom Segment',
  'Email Template',
  'Event',
  'External API',
  'Modal',
  'Page',
  'Page Layout',
  'PDF Template',
  'SMS Template',
  'Snippet',
  'Sub Page',
  'Tooltip Template',
  'Typesense Search Template',
  'Socket IO Template',
];
